import findCursor from './findCursor';
import { CURSOR_ANCHOR, CURSOR_FOCUS } from './whileMaintainingSelection';
export default function findCursors(editor) {
  return {
    anchorCursor: findCursor(editor, CURSOR_ANCHOR),
    focusCursor: findCursor(editor, CURSOR_FOCUS)
  };
}